export default [
    {
        id: 1,
        title: "Cat in a Box",
        location: "STUDIO",
        category: "PETS",
        date: "20 Dec, 2020",
        description: "My cat - Bruce, relaxing in a box wrapped in an old shirt.",
        image: require("./assets/images/cat-in-a-box.png")
    },
    {
        id: 2,
        title: "Mr. Noodles & Chowder",
        location: "SAN LEANDRO",
        category: "PETS",
        date: "2 Feb, 2021",
        description: "Backyard photoshoot for this crime-fighting doggy duo. Chowder (left) & Mr. Noodles (right).",
        image: require("./assets/images/noodles-and-chowder.png")
    },
    {
        id: 3,
        title: "Cap & Gown - Adriana",
        location: "CAL STATE - EAST BAY",
        category: "GRADUATION",
        date: "2 April, 2022",
        description: "Graduation shoot at some of the iconic locations at CSUEB.",
        image: require("./assets/images/cap-and-gown.png")
    },
    {
        id: 4,
        title: "Mr. Make Me Laugh",
        location: "SAN LORENZO - KENNEDY PARK",
        category: "HEADSHOT",
        date: "27 June, 2022",
        description: "Professional headshots for a good friend - Sean.",
        image: require("./assets/images/make-me-laugh.png")
    },
    {
        id: 5,
        title: "Ms. Audiologist",
        location: "CAL STATE - EAST BAY",
        category: "HEADSHOT",
        date: "27 April, 2022",
        description: "Professional headshots for the prettiest audiologist out there - Kylie.",
        image: require("./assets/images/ms-audiologist.png")
    },
    {
        id: 6,
        title: "Womens's Basketball - Madison",
        location: "CAL STATE - EAST BAY",
        category: "SPORTS",
        date: "26 Nov, 2021",
        description: "Basketball-themed photoshoot for CSUEB Women's Basketball Team member - Madison Schiller.",
        image: require("./assets/images/women's-basketball-madison.png")
    },
    {
        id: 7,
        title: "Mr. Iron Man Glasses - Fernando",
        location: "CAL STATE - EAST BAY",
        category: "HEADSHOT",
        date: "2 Oct, 2022",
        description: "Impromptu shoot for assistant coordinator - Fernando, during my time at RAW.",
        image: require("./assets/images/impromptu-headshot-fernando.png")
    },
    {
        id: 8,
        title: "Koi Dessert",
        location: "HOME - KITCHEN",
        category: "FOOD",
        date: "29 Jan, 2022",
        description: "Filled with lotus bean paste and the love of mom.",
        image: require("./assets/images/koi-dessert.png")
    },
    {
        id: 9,
        title: "Good Boy - Kairu",
        location: "SAN LORENZO - DUCK POND",
        category: "PETS",
        date: "8 Feb, 2021",
        description: "Golden hour outdoor park photoshoot for a good friend's dog - Kairu.",
        image: require("./assets/images/good-boy-kairu.png")
    },
    {
        id: 10,
        title: "I'm Not Your Model - Bruce",
        location: "STUDIO",
        category: "PETS",
        date: "11 Jan, 2022",
        description: "Another photoshoot for my cats. May there be many to come.",
        image: require("./assets/images/i'm-not-your-model-bruce.png")
    },
    {
        id: 11,
        title: "Kiki the Cat",
        location: "STUDIO",
        category: "PETS",
        date: "4 April, 2021",
        description: "Photoshoot for a friend's cat, Kiki.",
        image: require("./assets/images/kiki.png")
    }
]